import { h } from "preact";
import { useEffect, useRef } from "preact/hooks";
import flatpickr from "flatpickr";
import { German } from "flatpickr/dist/l10n/de.js";
import { useLocationFormStorage } from "./locationFormContext";

export function DateInput() {
  const inputRef = useRef();
  const pickerRef = useRef(null);
  const { setBookingFrom, setBookingTo, bookingFrom, bookingTo } =
    useLocationFormStorage();

  useEffect(() => {
    if (!inputRef.current) return;

    function setupPicker() {
      if (pickerRef.current) {
        pickerRef.current.destroy();
        pickerRef.current = null;
      }
      pickerRef.current = flatpickr(inputRef.current, {
        locale: German,
        dateFormat: "d.m.Y",
        defaultDate: bookingFrom && bookingTo ? [bookingFrom, bookingTo] : null,
        mode: "range",
        showMonths: window.matchMedia("(max-width: 767px)").matches ? 1 : 2,
        minDate: "today",
        maxDate: new Date().fp_incr(3 * 365),
        onChange: (selectedDates) => {
          setBookingFrom(selectedDates[0]);
          setBookingTo(selectedDates[1]);
        },
      });
    }

    setupPicker();
    window.addEventListener("resize", setupPicker);

    return () => {
      if (pickerRef.current) {
        pickerRef.current.destroy();
        pickerRef.current = null;
      }
      window.removeEventListener("resize", setupPicker);
    };
  }, []);

  return (
    <div
      id="locationFormDateInput"
      className="inputfield col-span-1 md:col-span-1"
    >
      <div class="inputfield__inputcontainer">
        <label
          class="inputfield__inputcontainer-label required left-8"
          for="search_form_dates"
        >
          {global.Translator.trans("locationform.date", {}, "js")}
        </label>

        <input
          className="inputfield__inputcontainer-control pl-8"
          placeholder={global.Translator.trans(
            "locationform.date_placeholder",
            {},
            "js"
          )}
          ref={inputRef}
          type="text"
          readonly="true"
          id="search_form_dates"
        />
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          height="24"
          width="24"
          className="absolute left-2.5 w-4 h-4 block top-5.5 hover:text-brandcopy-500"
        >
          <path
            d="M9.5 16.5h-7A0.5 0.5 0 0 1 2 16V7.5a0.5 0.5 0 0 1 0.5 -0.5H16a0.5 0.5 0 0 1 0.5 0.5v2s1.47 0 2 0.07V3a1 1 0 0 0 -1 -1H15a0.25 0.25 0 0 1 -0.25 -0.25v-1a0.75 0.75 0 0 0 -1.5 0V4.5a0.75 0.75 0 0 1 -1.5 0v-2a0.5 0.5 0 0 0 -0.5 -0.5H7a0.25 0.25 0 0 1 -0.25 -0.25v-1a0.75 0.75 0 0 0 -1.5 0V4.5a0.75 0.75 0 0 1 -1.5 0v-2a0.5 0.5 0 0 0 -0.5 -0.5H1a1 1 0 0 0 -1 1v13.5a2 2 0 0 0 2 2h7.57c-0.07 -0.5 -0.07 -1.99 -0.07 -2Z"
            fill="currentColor"
            stroke-width="1"
          ></path>
          <path
            d="M21.08 19.66a5.52 5.52 0 1 0 -4.55 2.4 5.46 5.46 0 0 0 3.13 -1l2.63 2.63a1 1 0 0 0 1.42 -1.42ZM13 16.53a3.53 3.53 0 1 1 3.53 3.53A3.53 3.53 0 0 1 13 16.53Z"
            fill="currentColor"
            stroke-width="1"
          ></path>
        </svg>
        {(bookingFrom !== null || bookingTo !== null) && (
          <button
            type="button"
            className="absolute right-3 top-5 text-brandcopy-700 hover:text-brandcopy-900 transition-all duration-150 ease-in-out"
            onClick={() => {
              setBookingFrom(null);
              setBookingTo(null);
              pickerRef.current.setDate([]);
            }}
          >
            <span className="sr-only">
              {global.Translator.trans("locationform.date_reset", {}, "js")}
            </span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              class="size-4"
            >
              <path
                fill-rule="evenodd"
                d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z"
                clip-rule="evenodd"
              />
            </svg>
          </button>
        )}
      </div>
    </div>
  );
}
